import LocalStorage from 'shared/LocalStorage'

export function getStoredTokenExp(): number | null {
  const sessionExp = window.sessionStorage.getItem('tokenExp')
  if (sessionExp) {
    return Number(sessionExp)
  }

  const localExp = LocalStorage.getItem('tokenExp')
  return localExp ? Number(localExp) : null
}

export function setStoredTokenExp(exp: number, stayLoggedIn: boolean) {
  if (stayLoggedIn) {
    LocalStorage.setItem('tokenExp', exp)
    window.sessionStorage.removeItem('tokenExp')
  } else {
    window.sessionStorage.setItem('tokenExp', exp.toString())
    LocalStorage.removeItem('tokenExp')
  }
}

export function usesPersistentTokenStorage(): boolean {
  return (
    LocalStorage.getItem('stayLoggedIn') === 'true' ||
    LocalStorage.getItem('tokenExp') !== null
  )
}

export function isTokenExpiringSoon(bufferSeconds = 120): boolean {
  const exp = getStoredTokenExp()
  if (!exp) {
    return true
  }

  return Date.now() >= (exp - bufferSeconds) * 1000
}

export function clearStoredTokenExp() {
  window.sessionStorage.removeItem('tokenExp')
  LocalStorage.removeItem('tokenExp')
}
